import React from 'react';
import { motion } from 'framer-motion';
import RoomBackground from './RoomBackground';
import FloorShadow from './FloorShadow';

export default function RoomSceneWrapper({ children }) {
  return (
    <div className="relative min-h-screen overflow-hidden px-0 py-0 md:px-[2.2cm] md:py-8 lg:py-10">
      <RoomBackground />

      {/* Foreground room container sits "inside" the room */}
      <motion.div
        initial={{ opacity: 0, y: 22 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6, ease: 'easeOut' }}
        className="relative z-10 w-full"
      >
        <div className="relative mx-auto w-full rounded-none md:rounded-[36px] border-0 md:border border-white/80 bg-[#FFFCF9]/58 backdrop-blur-xl shadow-[0_36px_88px_rgba(245,180,90,0.13)] px-3 py-3 md:px-6 md:py-6">
          {children}
          <FloorShadow />
        </div>
      </motion.div>
    </div>
  );
}
